var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-container" },
    [
      _c(
        "el-table",
        {
          directives: [{ name: "sticky-header", rawName: "v-sticky-header" }],
          attrs: {
            stripe: "",
            fit: "",
            "highlight-current-row": "",
            height: "500",
            data: _vm.list,
            "header-cell-class-name": "table-header-cell",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _vm.showCheck
            ? _c("el-table-column", {
                attrs: { type: "selection", width: "50", align: "center" },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              label: "序号",
              width: "60",
              align: "center",
              type: "index",
              "class-name": "table-header-cell",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.$index +
                            1 +
                            (_vm.queryParams.page - 1) * _vm.queryParams.limit
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "商品名称",
              prop: "goodsName",
              "min-width": "150",
              "class-name": "name-col",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "商品图片",
              prop: "cover",
              width: "100",
              align: "center",
              "class-name": "image-col",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-image", {
                      attrs: {
                        src: row.cover,
                        "preview-src-list": [row.cover],
                        lazy: "",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm.showOther
            ? _c("el-table-column", {
                attrs: {
                  label: "用户身份",
                  prop: "userGrade",
                  width: "80",
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [_vm._v(_vm._s(row.gradeName))]
                      },
                    },
                  ],
                  null,
                  false,
                  4269589357
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              label: "礼包分类",
              prop: "giftType",
              width: "100",
              align: "center",
              "class-name": "status-col",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "flex-tag" },
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "success",
                              effect: row.giftType === 1 ? "plain" : "dark",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                row.giftType === 1 ? "收益礼包" : "身份礼包"
                              )
                            ),
                          ]
                        ),
                        row.categoryName
                          ? _c(
                              "el-tag",
                              { attrs: { type: "info", effect: "dark" } },
                              [_vm._v(_vm._s(row.categoryName))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "进价和成本", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("p", [
                      _c("span", { staticClass: "bold" }, [_vm._v("供货价：")]),
                      _vm._v(_vm._s(_vm._f("filterPrice")(row.stockPrice))),
                    ]),
                    _c("p", [
                      _c("span", { staticClass: "bold" }, [_vm._v("成本价：")]),
                      _vm._v(_vm._s(_vm._f("filterPrice")(row.costPrice))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "零售价", width: "100", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(_vm._s(_vm._f("filterPrice")(row.retailPrice))),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "售价", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("p", [
                      _c("span", { staticClass: "bold" }, [_vm._v("现金：")]),
                      _vm._v(_vm._s(_vm._f("filterPrice")(row.pointPrice))),
                    ]),
                    _c("p", [
                      _c("span", { staticClass: "bold" }, [_vm._v("积分：")]),
                      _vm._v(_vm._s(_vm._f("filterPrice")(row.point))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "供应商",
              "min-width": "100",
              prop: "supplierName",
            },
          }),
          _vm.showOther
            ? _c("el-table-column", {
                attrs: { label: "上架状态", width: "100", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "flex align-center just-center" },
                            [
                              _c("el-switch", {
                                staticClass: "rectangle md",
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleUpdate(row, "isOnsale")
                                  },
                                },
                                model: {
                                  value: row.isOnsale,
                                  callback: function ($$v) {
                                    _vm.$set(row, "isOnsale", $$v)
                                  },
                                  expression: "row.isOnsale",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1577243102
                ),
              })
            : _vm._e(),
          _vm.showOther
            ? _c("el-table-column", {
                attrs: {
                  label: "操作",
                  align: "center",
                  width: "100",
                  fixed: "right",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.handleEdit(row.id)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.handleRemove(row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3360066376
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("pagination", {
        attrs: {
          total: _vm.total,
          page: _vm.queryParams.page,
          limit: _vm.queryParams.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.queryParams, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.queryParams, "limit", $event)
          },
          pagination: _vm.fetchData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }